import { FC } from 'react';
import { Typography } from '@mui/material';

import { ReactComponent as BackIcon } from '../../assets/icons/chevron-left.svg';
import { StyledIconButton } from './intake.styles';

interface ButtonProps {
  onClick: () => void;
}

const StyledBackButton: FC<ButtonProps> = ({ onClick }) => {
  return (
    <StyledIconButton startIcon={<BackIcon />} onClick={onClick}>
      <Typography color='var(--neutral-primary)'>Back</Typography>
    </StyledIconButton>
  );
};

export default StyledBackButton;
